/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface Query
 */
export interface Query {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof Query
     */
    eventId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof Query
     */
    quantity: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof Query
     */
    promoCode?: string | null;
}

/**
 * Check if a given object implements the Query interface.
 */
export function instanceOfQuery(value: object): value is Query {
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function QueryFromJSON(json: any): Query {
    return QueryFromJSONTyped(json, false);
}

export function QueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Query {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['eventId']),
        'quantity': ApiUserTasksGetPageParameterFromJSON(json['quantity']),
        'promoCode': json['promoCode'] == null ? undefined : json['promoCode'],
    };
}

export function QueryToJSON(json: any): Query {
    return QueryToJSONTyped(json, false);
}

export function QueryToJSONTyped(value?: Query | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['eventId']),
        'quantity': ApiUserTasksGetPageParameterToJSON(value['quantity']),
        'promoCode': value['promoCode'],
    };
}

